import React, { useState, useContext, useRef, useEffect, createContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/promoItemExchange.css';
// import '../../../css/BillForKitchen.css';
import axios from "axios";
import { API } from "../../../services/api";
import Alert from "../../../components/alert";
import { useReactToPrint } from 'react-to-print';
import { AlertContext, UserContext } from "../../../App";
import smoothies from '../../../img/icon/menu/smoothies.png';

    axios.defaults.baseURL = API;

    const POSContent = createContext();

    function PromoItem() {

        function getDate() {
            const today = new Date();
            const month = today.getMonth() + 1;
            const year = today.getFullYear();
            const date = today.getDate();
            const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
            return `${year}-${month}-${date} ${time}`;
        }

    const componentRefFood = useRef();
    const componentRefDrink = useRef();
    const componentRef = useRef();

    const {userID, UserName, LocationID, LocationName, Address, Tell, Role, ShowForm, setShowForm, setshowSubmenu} = useContext(UserContext);
    const {showAlert, setShowAlert, errorMessage, setErrorMessage, device, setDevice, status, setStatus, EPSON_VENDOR_ID} = useContext(AlertContext);


    const [TakeAway, setTakeAway] = useState("Dine In (ກິນຢູ່ຮ້ານ)");
    const [tw, setTw] = useState(false);
    const [SubTotal, setSubTotal] = useState([]);

    const [PromoItemData, setPromoItemData] = useState([]);
    const [PromoItemList, setPromoItemList] = useState([]);
    const [MemberID, setMemberID] = useState(0);
    const [MemberPoint, setMemberPoint] = useState(0);
    const [MemberNewPoint, setMemberNewPoint] = useState(0);
    const [MemberNO, setMemberNO] = useState("");
    const [Name, setName] = useState(0);
    const [PrintCount, setPrintCount] = useState(2);
    const [loading, setLoading] = useState(false);


    let receipt = '';
    const ESC = '\x1B';
    const GS = '\x1D';
    const CMD = {
        INIT: ESC + '@',             // Initialize printer
        ALIGN_LEFT: ESC + 'a\x00',   // Left alignment
        ALIGN_CENTER: ESC + 'a\x01', // Center alignment
        ALIGN_RIGHT: ESC + 'a\x02',  // Right alignment
        FONT_NORMAL: ESC + '!', // Select normal font (Font A)
        FONT_Size: ESC + '!' + 1,     
        FONT_SizeNomal: ESC + '!' + 0,    
        FONT_BOLD: ESC + 'E\x01',    // Turn on bold
        FONT_REGULAR: ESC + 'E\x00', // Turn off bold
        FEED_CUT: GS + 'V\x41\x03',  // Feed paper and cut (Partial cut)
    };

    const formatLeftRight = (leftText, rightText, maxChars = 48) => {
        const spacesNeeded = maxChars - (leftText.length + rightText.length);
        if (spacesNeeded <= 0) {
        return leftText.substring(0, maxChars - rightText.length - 1) + ' ' + rightText + '\n';
        }
        return leftText + ' '.repeat(spacesNeeded) + rightText + '\n';
    };

    const PrintBillDetail = (gTransactionID) => {
        setLoading(true);
        let receipt = '';

        // 1. Initialize Printer
        receipt += CMD.INIT;

        // 2. Header Section (Centered)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Manee Arabica Coffee'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += `${Address}\n`;
        receipt += `Tel: (+856) ${Tell}\n`;
        receipt += '-'.repeat(48) + '\n'; // Divider

        

        // 3. Metadata Section (Left Aligned)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + `Exchange`.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += CMD.ALIGN_LEFT;
        receipt += `BILL ID# ${gTransactionID}\n`;
        receipt += `Date: ${new Date().toLocaleDateString()}\n`;
        receipt += `Cashier: ${UserName}\n`;
        receipt += '-'.repeat(48) + '\n';


        // 4. Items Loop (Dynamic Columns Formatting)
        receipt += ("Item/Qty                                   Price\n");
        receipt += '='.repeat(48) + '\n';
        PromoItemData.forEach((item) => {
        const quantityText = `${item.Quantity}x  ${currencyFormat(item.Retail_Price)}`;
        const totalText = `${(item.Quantity * item.Retail_Price)}`;

        // Row 1: Print Item Name (Wrap safely if too long)
        if (item.EngName.length > 48) {
            receipt += item.EngName.substring(0, 48) + '\n';
        } else {
            receipt += item.EngName + '\n';
        }

        // Row 2: Sub-row containing calculated item metrics right aligned
        receipt += formatLeftRight(`  ${quantityText}`, currencyFormat(totalText));
        });

        receipt += '-'.repeat(48) + '\n';
        receipt += CMD.FONT_BOLD;
        receipt += formatLeftRight("TOTAL:", `${currencyFormat(SubTotal)}`);
        receipt += CMD.FONT_REGULAR;
        receipt += '='.repeat(48) + '\n';
        receipt += formatLeftRight("Card Number:", `${MemberNO}`);
        receipt += formatLeftRight("Previous Point:", `${currencyFormat(MemberPoint)}`);
        receipt += formatLeftRight("Use Point:", `${currencyFormat(SubTotal)}`);
        receipt += formatLeftRight("New Point:", `${currencyFormat(MemberPoint)}`);
        receipt += '='.repeat(48) + '\n';

        // 6. Footer & Auto-Cut
        receipt += CMD.ALIGN_CENTER;
        receipt += "Thank you for your visit!\n";
        receipt += "Please come again\n\n\n\n"; // Feeds space before cutting
        receipt += CMD.FEED_CUT;

        // Convert string to Uint8Array for binary transmission
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(receipt);
        
        setLoading(false);
        return uint8Array;
    };

    const handlePrintBill = async (gTransactionID) => {
        if(device){
        const endpointOut = device.configuration.interfaces[0].alternate.endpoints.find(
            (ep) => ep.direction === 'out' && ep.type === 'bulk'
        );
        const endpointNumber = endpointOut.endpointNumber;
        const rawBuffer = PrintBillDetail(gTransactionID);
        await device.transferOut(endpointNumber, rawBuffer);
        }
    };

    const handleSearchMember = e => {
        const { name, value } = e.target;
        setMemberNO(value);
        setPromoItemList("");
        if(value){
            SearchMember(value);
        } else {

        }
    }

  const handleInputPrintCount = event => { 
        const { name, value } = event.target;
        setPrintCount(value)
    };

  const handleClickTakeAway = event => {
        if(tw){
            setTakeAway("Dine In (ກິນຢູ່ຮ້ານ)");
            setTw(false);
        }else {
            setTakeAway("TakeAway (ກັບບ້ານ)");
            setTw(true);
        }  
    };

    function currencyFormat(num) {
        if (num !== "" && num > 0) {
            return Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    }

    async function SearchMember(memberNO) {
        setPromoItemData([]);
        let token = localStorage.getItem("token");
        var data = {
            MemberNO: memberNO
        }
        await axios.post("/searchMember", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let memberData = response?.data;
            if(memberData.length > 0){
                setMemberID(memberData[0].MemberID);
                setName(memberData[0].FirstName + ' ' + memberData[0].LastName);
                setMemberPoint(memberData[0].Point);
                setMemberNewPoint(memberData[0].Point);
                getAllPromoProductByMemberPoint(memberData[0].Point);
            } else {
                setMemberID("");
                setName("");
                setMemberPoint("");
            }

        }).catch((err) => {
            console.log(err);
            setMemberID("");
            setName("");
            setMemberPoint("");
        });
    };

    async function getAllPromoProductByMemberPoint (Point) {
        if(Point){
            var data={
                Point: Point,
            }
        let token = localStorage.getItem("token");
        await axios.post(`/getAllPromoProductByMemberPoint`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            if(temOrder.length > 0){
                setPromoItemList(temOrder);
            } else {
                setPromoItemList("");
            }
        }).catch((err) => {
            console.log(err);
        });
        } else {
            setPromoItemList("");
        }
    }

    async function addOrder(ProductID, ProductType, Point, Retail_Price, LaoName, EngName, qty, ImgUrl) {
        var c =0;
        for (var i=0; i < PromoItemData.length; i++) {
            if (PromoItemData[i].ProductID == ProductID) {
                if(Number(PromoItemData[i].Quantity) + Number(qty) > 0)
                {
                    if(qty > 0){
                        if(MemberNewPoint >= Point){
                            var nPoint = Number(MemberNewPoint) - Number(Point);
                            setMemberNewPoint(nPoint);
                            PromoItemData[i].LaoName = PromoItemData[i].LaoName;
                            PromoItemData[i].EngName = PromoItemData[i].EngName;
                            PromoItemData[i].Quantity = Number(PromoItemData[i].Quantity) + Number(qty);
                            PromoItemData[i].SubTotal = Number(PromoItemData[i].Quantity) * Number(PromoItemData[i].Point);
                        } else {
                            setErrorMessage("ຄະແນນບໍ່ພຽງພໍ");
                            setShowAlert(true);
                        }
                    } else {
                        var nPoint = Number(MemberNewPoint) + Number(Point);
                        setMemberNewPoint(nPoint);
                        PromoItemData[i].LaoName = PromoItemData[i].LaoName;
                        PromoItemData[i].EngName = PromoItemData[i].EngName;
                        PromoItemData[i].Quantity = Number(PromoItemData[i].Quantity) + Number(qty);
                        PromoItemData[i].SubTotal = Number(PromoItemData[i].Quantity) * Number(PromoItemData[i].Point);
                    }
                } else {
                    setMemberNewPoint(MemberPoint);
                    PromoItemData.splice(i, 1);
                }
                c = 1;
                break;
            }
        }  
        if(c == 0){
            if(MemberNewPoint >= Point){
                var nPoint = Number(MemberNewPoint) - Number(Point);
                setMemberNewPoint(nPoint);
                var data = {
                    ProductID: ProductID,
                    LaoName: LaoName,
                    EngName: EngName,
                    Quantity: 1,
                    Point: Point,
                    SubTotal: Point,
                    ProductType: ProductType,
                    PrintStatus: "N",
                    Retail_Price: Retail_Price
                };
                PromoItemData.push(data);
            } else {
                setErrorMessage("ຄະແນນບໍ່ພຽງພໍ");
                setShowAlert(true);
            }
        }
        getSubtotal(); 
    }

    const getSubtotal = () => {
        if (PromoItemData) {
            if(PromoItemData.length > 0){
                var gSubTotal = 0;
                for (var i=0; i < PromoItemData.length; i++) {
                    gSubTotal = Number(gSubTotal) + Number(PromoItemData[i].SubTotal);
                }  
                setSubTotal(gSubTotal);
            } else{
                setSubTotal(0);
            }

        } else{
            setSubTotal(0);
        }
    }

    const handlePayment = () => {
        if(PromoItemData.length > 0){
            CreateTransaction();
        } else{
             setErrorMessage("ກະລຸນາເລືອກສິນຄ້າກ່ອນ");
             setShowAlert(true);
        }
    }

    const PrintfoodBillDetail = () => {
        setLoading(true);
        let receipt = '';
        let SubTotal = 0;

        // 1. Initialize Printer
        receipt += CMD.INIT;

        // 2. Header Section (Centered)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Manee Arabica Coffee'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += `${Address}\n`;
        receipt += `Tel: (+856) ${Tell}\n`;
        receipt += '-'.repeat(48) + '\n'; // Divider

        // 3. Metadata Section (Left Aligned)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Food Bill'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += CMD.ALIGN_LEFT;
        receipt += `Date: ${new Date().toLocaleDateString()}\n`;
        receipt +=  '\n';

        // 4. Items Loop (Dynamic Columns Formatting)
        receipt += ("Item/Qty                                   Price\n");
        receipt += '='.repeat(48) + '\n';
        PromoItemData.forEach((item) => {
            if(item.ProductType == "Food" || item.ProductType == "FOOD"){
                const quantityText = `${item.Quantity}x ${currencyFormat(item.Retail_Price)}`;
                const totalText = `${(item.Quantity * item.Retail_Price).toFixed(0)}`;

                // Row 1: Print Item Name (Wrap safely if too long)
                if (item.EngName.length > 47) {
                    receipt += item.EngName.substring(0, 47) + '\n';
                } else {
                    receipt += item.EngName + '\n';
                }

                // Row 2: Sub-row containing calculated item metrics right aligned
                receipt += formatLeftRight(`  ${quantityText}`, currencyFormat(totalText));
                SubTotal = (Number(item.Retail_Price) * Number(item.Quantity));
            }
        });

        receipt += '-'.repeat(48) + '\n';
        // Bold total row
        receipt += CMD.FONT_BOLD;
        receipt += formatLeftRight("TOTAL:", `${currencyFormat(SubTotal)}`);
        receipt += CMD.FONT_REGULAR;
        receipt += '-'.repeat(48) + '\n';

        // 6. Footer & Auto-Cutg
        receipt += CMD.FEED_CUT;

        // Convert string to Uint8Array for binary transmission
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(receipt);
        
        setLoading(false);
        return uint8Array;
    };

    const PrintDrinkBillDetail = () => {
        setLoading(true);
        let receipt = '';
        let SubTotal = 0;

        // 1. Initialize Printer
        receipt += CMD.INIT;

        // 2. Header Section (Centered)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Manee Arabica Coffee'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += `${Address}\n`;
        receipt += `Tel: (+856) ${Tell}\n`;
        receipt += '-'.repeat(48) + '\n'; // Divider

        // 3. Metadata Section (Left Aligned)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Drink Bill'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += CMD.ALIGN_LEFT;
        receipt += `Date: ${new Date().toLocaleDateString()}\n`;
        receipt += '\n';

        // 4. Items Loop (Dynamic Columns Formatting)
        receipt += ("Item/Qty                                   Price\n");
        receipt += '='.repeat(48) + '\n';
        PromoItemData.forEach((item) => {
            if(item.ProductType == "Drink" || item.ProductType == "DRINK" || item.ProductType == "Coffee" || item.ProductType == "COFFEE" || item.ProductType == "Bakery" || item.ProductType == "BAKERY"){
                const quantityText = `${item.Quantity}x ${currencyFormat(item.Retail_Price)}`;
                const totalText = `${(item.Quantity * item.Retail_Price).toFixed(0)}`;

                // Row 1: Print Item Name (Wrap safely if too long)
                if (item.EngName.length > 47) {
                    receipt += (item.EngName + ' Sugar: ' + item.Sugar + '%').substring(0, 47) + '\n';
                } else {
                    receipt += item.EngName + ' Sugar: ' + item.Sugar  + '%' + '\n';
                }

                // Row 2: Sub-row containing calculated item metrics right aligned
                receipt += formatLeftRight(`  ${quantityText}`, currencyFormat(totalText));
                SubTotal = (Number(item.Retail_Price) * Number(item.Quantity));
            }
        });

        receipt += '-'.repeat(48) + '\n';
        // Bold total row
        receipt += CMD.FONT_BOLD;
        receipt += formatLeftRight("TOTAL:", `${currencyFormat(SubTotal)}`);
        receipt += CMD.FONT_REGULAR;
        receipt += '-'.repeat(48) + '\n';

        // 6. Footer & Auto-Cutg
        receipt += CMD.FEED_CUT;

        // Convert string to Uint8Array for binary transmission
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(receipt);
        
        setLoading(false);
        return uint8Array;
    };

const connectPrinter = async () => {
        try {
            setStatus('Connecting...');
            
            // Request permission to access the USB device
            const selectedDevice = await navigator.usb.requestDevice({
                filters: [{ vendorId: EPSON_VENDOR_ID }]
            });

            await selectedDevice.open();
            
            // Select configuration (most USB printers use configuration 1)
            if (selectedDevice.configuration === null) {
                await selectedDevice.selectConfiguration(1);
            }
            
            // Claim the primary interface (usually interface 0)
            await selectedDevice.claimInterface(0);

            setDevice(selectedDevice);
            setStatus(`Connected to: ${selectedDevice.productName || 'Epson Printer'}`);
            } catch (error) {
                console.error('USB Connection Error:', error);
                setStatus(`Connection failed: ${error.message}`);
            }
    };

    const handlePrintFood = async () => {
        if(device){
            const endpointOut = device.configuration.interfaces[0].alternate.endpoints.find(
                (ep) => ep.direction === 'out' && ep.type === 'bulk'
            );
            const endpointNumber = endpointOut.endpointNumber;
            const rawBuffer = PrintfoodBillDetail();
            await device.transferOut(endpointNumber, rawBuffer);
        } else {
            connectPrinter();
        }
    };

    const handlePrintDrink = async () => {
        if(device){
            const endpointOut = device.configuration.interfaces[0].alternate.endpoints.find(
                (ep) => ep.direction === 'out' && ep.type === 'bulk'
            );
            const endpointNumber = endpointOut.endpointNumber;
            const rawBuffer = PrintDrinkBillDetail();
            await device.transferOut(endpointNumber, rawBuffer);
        }
    };

    async function CreateTransaction(){
        let token = localStorage.getItem("token");
        var data = {
            MemberID: MemberID,
            PreviousPoint: MemberPoint,
            UsePoint: SubTotal,
            Point: MemberNewPoint,
            CreatedBy: userID,
            CreatedDate: getDate(),
            StatusID: 1,
            LocationID: LocationID
          };
          
        await axios.post("/CreatePromoItemExchangeTransaction", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            UpdateMember(MemberID);
            CreateTransactionDetail(response?.data?.insertId);
            handlePrintBill(response?.data?.insertId);
            ClearData();
        }).catch((err) => {
            console.log(err);
        });
    }

    const ClearData = () => {
        const timeout = setTimeout(() => {
            setPromoItemList([]);
            setPromoItemData([]);
            setMemberNewPoint(0);
            setMemberNO("");
            setMemberPoint(0);
            setMemberID("");
            setName("");
        }, 3000);
        return () => clearTimeout(timeout);
    }

    async function UpdateMember() {
        let token = localStorage.getItem("token");
        var data = {
            MemberID: MemberID,
            Point: MemberNewPoint,
        }
        await axios.post("/UpdateMemberPoint", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    };

    async function CreateTransactionDetail (ExchangeID) {
        let token = localStorage.getItem("token");
        for (var i=0; i < PromoItemData.length; i++) {
            var data = {
                ExchangeID: ExchangeID,
                ProductID: PromoItemData[i].ProductID,
                Quantity: PromoItemData[i].Quantity,
                Point: PromoItemData[i].Point,
            };
            await axios.post("/CreatePromoItemExchangeTransactionDetail", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {

            }).catch((err) => {
                console.log(err);
            });
        }  
    }

    const handleclickBack = () => {
        setShowForm(false);
        setshowSubmenu(true);
    };

  return (
      <div className="PromoItemFormContents" >
        <Alert/> 
        <div className="PromoLeftContent">
            <div className="SearchMember">
                <div className="txtMemberNO"><p>ຂໍ້ມູນບັດ Member</p></div>
                <input className={`input form-control MemberNO`} type="text" name="MemberNO" onChange={(e) => handleSearchMember(e)}  value={MemberNO || ''} required />
            </div>
            <div className="Promolist">
                <div className="Promo_MenuList">
                    {
                            PromoItemList && PromoItemList.map((x, y) => {
                                return (
                                    <div key={y} className="promitem" onClick={() => addOrder(x.ProductID, x.ProductType, x.Point, x.Retail_Price, x.LaoName, x.EngName, 1, x.ImgUrl)}>
                                        <div className="promitem-header">
                                            <img src={smoothies} className="img-product" />
                                        </div>
                                        <div className="promitem-body">
                                            <div className="name">
                                                <p>{x.LaoName}</p>
                                            </div>
                                            <p className="Point">Point: {x.Point}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                </div>
            </div>
        </div>
        <div className="PromoRightContent">
            <div className="MemberInfo">
                <div className="txtNO"><p>ເລກບັດ: </p><p>{MemberNO}</p></div>
                <div className="txtMemberName"><p>ຊື່: </p><p>{Name}</p></div>
                <div className="txtPoint"><p>ຄະແນນ: </p><p>{MemberPoint}</p></div>
                <div className="txtNewPoint"><p>ຍອດເຫຼືອ:</p><p>{MemberNewPoint}</p></div>
            </div>
            <div className="OrderHead">
                <div className="LaoName"><p>ຊື່ສິນຄ້າ</p></div>
                <div className="Quantity">ຈຳນວນ</div>
                <div className="point">ຄະແນນ</div>
            </div>
            <div className="promoRightSidenavContent">
                {
                    PromoItemData && PromoItemData.map((x, y) => {
                        return (
                            <div key={y} className="orderContent">
                                <div className="orderFooter">
                                    <div className="price">
                                        <p>{currencyFormat(x.Retail_Price)}</p>
                                    </div>
                                    <div className="plus" onClick={() => addOrder(x.ProductID, x.ProductType, x.Point, x.Retail_Price, x.LaoName, x.EngName, 1, x.ImgUrl)}>
                                        +
                                    </div>
                                    <div className="quantity">
                                        <p>{currencyFormat(x.Quantity)}</p>
                                    </div>
                                    <div className="minus" onClick={() => addOrder(x.ProductID, x.ProductType, x.Point, x.Retail_Price, x.LaoName, x.EngName, -1, x.ImgUrl)}>
                                        -
                                    </div>
                                    <div className="Subtotal">
                                        <p>{currencyFormat(x.Quantity * x.Point)}</p>
                                    </div>
                                </div>
                                <div className="orderBody">
                                    <div className="detail">
                                        <div className="LaoName">
                                            <span>{y+1}. {x.LaoName}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <div className="PromoRightSidenavBottom">
                <div className="footer-subtotal">
                    <div className="footer-line"></div>
                    <div className="nettotal">
                        <span>Sutotal:</span>
                        <strong>{SubTotal}</strong>
                    </div>
                </div>
                <div className="paymentMethod">
                    <div className="btnpayment" onClick={(e) => handlePayment()}>
                        <span>Payment</span>
                    </div>
                    <div className="btnPrintFood" onClick={(e)=> handlePrintFood()} >
                        <span>Print Food</span>
                    </div>
                    <div className="btnPrintDrink" onClick={(e)=> handlePrintDrink()}>
                        <span>Print Drink</span>
                    </div>
                     <div className="btnPrintDrink" onClick={() => handleclickBack()}>
                        <span>Back</span>
                    </div>
                </div>
                <div className="form-group">
                    {/* <label className="form-check form-check-inline takeAway">
                        <input className="form-check-input" type="radio" name="takeAway" value="TakeAway" onClick={(e) => handleClickTakeAway(e)} checked={tw} />
                        <span className="form-check-label"> TakeAway </span>
                    </label> */}
                    <div className="headerPrintcount">
                        <span>ຈຳນວນບິນ:</span>
                        <input className="PrintCount" type="text" name="PrintCount" placeholder="1" onChange={(e) => handleInputPrintCount(e)} value={PrintCount} required />
                    </div>
                </div>
            </div>
        </div>
      </div>
  );
};

export default PromoItem;
